
export const AppMessages = {
  noDriverScore: "Not enough miles driven to receive a score for the current time period.",
  noOrganizationScore: "No drivers with enough miles driven to receive a score for the current time period.",
  noOffendingDrivers: 'Congratulations on your outstanding driver management!  Your team had no severe issues!',
  noMissedAcknowledgments: 'No Missed Acknowledgments',
  noIncidents: 'Congratulations!  You had no severe issues last period!',
  confirmAcknowledgment: 'We appreciate your commitment to safety and efficiency. \r\nBy clicking below, you are acknowledging that you have reviewed your driver scorecard. If you have any questions about your score, please contact your supervisor.'
};